module.exports = "<ion-content>\n  <app-temprature-card [commonData]=\"veh\"></app-temprature-card>\n</ion-content>"